import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { BANNER_CONFIG } from './constants';

const getAdfoxScript = (): any => {
  const { Ya: { adfoxCode } = {} } = window;
  return adfoxCode;
};

const initBanner = ({ handleFail, allowRetry = false }) => {
  const adfoxCode = getAdfoxScript();

  if (adfoxCode) {
    adfoxCode.create(BANNER_CONFIG);
  } else if (allowRetry) {
    setTimeout(() => initBanner({ handleFail }), 2000);
  } else {
    handleFail();
  }

  return destroyBanner;
};

const destroyBanner = () => {
  const adfoxCode = getAdfoxScript();

  if (!adfoxCode) return;

  adfoxCode.destroy(BANNER_CONFIG.containerId);
};

const AdfoxGalleryBanner = () => {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const props = {
      handleFail: () => setHidden(true),
      allowRetry: true,
    };

    initBanner(props);
  }, []);

  if (hidden) return null;

  return (
    <Container>
      <div id={BANNER_CONFIG.containerId} />
    </Container>
  );
};

const Container = styled.div`
  margin: 0;
  position: relative;
  z-index: 1;

  width: 100%;
  height: 160px;
  background-color: #459ccd;
  overflow: hidden;
`;

export default AdfoxGalleryBanner;
